import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-dispose';

const find = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/globalConfig`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/orderConfigs`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/orderConfigs/${id}`, payload);
};

const updateGlobalConfigs = (merchantId, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/globalConfigs`, payload);
};

export default {
	create,
	find,
	update,
	updateGlobalConfigs,
};
